import { Colors } from '@src/colors';
import styled from 'styled-components';

export const ComponentDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${Colors.duskLighter};
`;

export const HeaderDiv = styled.div`
    width: 100%;
    cursor: pointer;
`;

export const ExpandableDiv = styled.div<{ open: boolean }>`
    position: relative;
    display: ${(props) => (props.open ? 'block' : 'none')};
    width: 100%;
    max-height: ${(props) => (props.open ? 'min-content' : '0px')};
`;

export const IconSpan = styled.div`
    position: relative;
    display: inline-block;
    width: 18px;
    height: 18px;
    top: -1px;

    svg {
        path {
            fill: ${Colors.duskLighter};
        }
    }
`;
